import { render, staticRenderFns } from "./RsFormObject.vue?vue&type=template&id=a1e31c24&scoped=true"
import script from "./RsFormObject.vue?vue&type=script&lang=js"
export * from "./RsFormObject.vue?vue&type=script&lang=js"
import style0 from "./RsFormObject.vue?vue&type=style&index=0&id=a1e31c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e31c24",
  null
  
)

export default component.exports